export function validatePhone(value) {
    const length = value.length;
    if( length < 1 ) {       
        return {
        	value: value,
            isValid : false,
            message : "Error: Please enter a Phone Number."
        }
    } else if (length > 30) {
        return {
        	value: value,
            isValid : false,
            message : "Error: Phone Number cannot exceed 30 characters in length."
        }
    } else if (length >= 1 && length <= 30) {
      const PHONENUMBER_EXTN_PATTERN = /^[\w- ]*$/;
      let matches = PHONENUMBER_EXTN_PATTERN.test(value);
      if(!matches){
          return {
        	value: value,
            isValid : false,
            message : "Error: Please enter alphanumeric characters, spaces and dashes only."
          }
      } else {
          return{
        	value: value,
            isValid : true,
            message : ""
          }
      }
   }
}

export default validatePhone;


// WEBPACK FOOTER //
// ./src/helper/validatePhoneNumber.js